"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.client = undefined;

var _apolloClient = require("apollo-client");

var _apolloClient2 = _interopRequireDefault(_apolloClient);

var _subscriptionsTransportWs = require("subscriptions-transport-ws");

var _printer = require("graphql-tag/printer");

var _consts = require("./consts");

var _getJWT = require("./getJWT");

var _getJWT2 = _interopRequireDefault(_getJWT);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var networkInterface = (0, _apolloClient.createNetworkInterface)({
	uri: _consts.scapholdURL
});

var dataIdFromObject = R.prop("id");

var customResolvers = {
	Query: R.pipe(R.map(function (type) {
		return ["get" + type, function (_, _ref) {
			var id = _ref.id;
			return (0, _apolloClient.toIdValue)(dataIdFromObject({ id: id }));
		}];
	}), R.fromPairs)(["Module", "Doc", "Folder", "User"])
};

networkInterface.use([{
	applyMiddleware: function applyMiddleware(req, next) {
		if (!req.options.headers) {
			req.options.headers = {}; // Create the header object if needed.
		}

		(0, _getJWT2.default)().then(function (jwt) {
			req.options.headers.Authorization = "Bearer " + jwt;

			next();
		});
	}
}]);

var wsClient = new _subscriptionsTransportWs.Client(_consts.scapholdSubURL);
console.log("wsClient", wsClient);

var addGraphQLSubscriptions = function addGraphQLSubscriptions(networkInterface, wsClient) {
	return Object.assign(networkInterface, {
		subscribe: function subscribe(request, handler) {
			return wsClient.subscribe({
				query: (0, _printer.print)(request.query),
				variables: request.variables
			}, handler);
		},
		unsubscribe: function unsubscribe(id) {
			wsClient.unsubscribe(id);
		}
	});
};

var networkInterfaceWithSubs = addGraphQLSubscriptions(networkInterface, wsClient);

var client = exports.client = new _apolloClient2.default({
	networkInterface: networkInterfaceWithSubs,
	customResolvers: customResolvers,
	dataIdFromObject: dataIdFromObject,
	connectToDevTools: true
});

//# sourceMappingURL=apolloClient.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/apolloClient.js
// module id = 368
// module chunks = 0